<template>
    <text-input
      :label="label"
      :prop="prop"
      :required="required"
      type="number"
      :decimals="decimals"
      v-model="form"
      :pattern="pattern"
      :size="size"
      align-input="right"
      :min="min"
      :max="max"
      :prefix="isSuffixSymobl ? null : currency"
      :suffix="isSuffixSymobl ? currency : null"
      @input="v = parseFloat($event)"
     :disabled="disabled"
     :placeholder="placeholder"
     :no-form="noForm"
     @change="updated">
   </text-input>
</template>

<script>

import NumberMixins from '@/mixins/NumberMixins'
import {settings} from '@/components/Data'

export default {
  name: 'currency-input',

  mixins: [NumberMixins],

  props: {

    label: {
      type: String,
      default: 'Amount'
    },

    value: {
//      type: Number,
      required: true
    },

    prop: {
      type: String,
      default: null
    },

    decimals: {
      type: Number,
      default: 2
    },

    pattern: {
      type: Number,
      default: null
    },

    min: {
      type: Number,
      default: 0
    },

    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },

    size: {
      type: String,
      default: 'default'
    },


    isSuffixSymobl: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updated (value) {
      this.$emit('input', Number(value))
      this.$emit('change', Number(value))
    }
  },

  watch: {
    value: function (val) {
      this.form = val
    }
  },


  data () {
    return {
      form: this.value,
      currency: settings.currency
    }
  }

}
</script>

<style scoped>
input {
  float: right;
  clear: both;
}
</style>



// WEBPACK FOOTER //
// CurrencyInput.vue?2b231436